import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { FormHelperText } from "@mui/material";

import { handleInputEvent } from "../../utils";

export interface FormInputProps {
  control: any;
  name: string;
  helper?: any;
  label?: string;
  style?: any;
  inputType?: any;
  placeholder?: string;
  disabled?: boolean;
  multiline?: boolean;
  textLength?: number;
  searchInputRef?: any;
  onFocus? : () => void
}


export const FormInputText = ({
  control,
  name,
  helper,
  label,
  style,
  inputType,
  placeholder,
  disabled,
  multiline,
  textLength,
  searchInputRef,
  onFocus
}: FormInputProps) => {
  return (
    <>
      <Controller
        name={name}
        control={control}
        defaultValue={""}
        rules={helper}
        render={({
          field: { onChange, value, ref, onBlur },
          fieldState: { error },
        }) => (
          <>
            <TextField
              id={`${name}-input`}
              required={true}
              error={error !== undefined}
              rows={multiline ? 4 : 1}
              sx={{
                ...style,
              }}
              onChange={(e) => {
                onChange(e);
              }}
              onInput={(e) => {
                handleInputEvent(e, inputType);
              }}
              placeholder={
                name.includes("streetName1")
                  ? "Enter a location"
                  : placeholder
              }
              disabled={disabled}
              multiline={multiline || false}
              inputProps={{
                maxLength: textLength ? textLength : 50,
                ref: searchInputRef ? searchInputRef : null,
                autoComplete: "none",
              }} // text
              value={value || ""}
              onBlur={onBlur}
              inputRef={ref}
              variant="outlined"
              onFocus={() => onFocus !== undefined &&  onFocus()}
              label={label ? label : ""}
            />
            {helper && error && error.message && (
              <FormHelperText>{error ? error.message : null}</FormHelperText>
            )}
          </>
        )}
      />
    </>
  );
};
